import { render, staticRenderFns } from "./ConnectionMenu.vue?vue&type=template&id=b2551764&scoped=true&"
import script from "./ConnectionMenu.vue?vue&type=script&lang=js&"
export * from "./ConnectionMenu.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionMenu.vue?vue&type=style&index=0&id=b2551764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2551764",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAlert,VBtn,VDivider,VMenu,VSheet})
